import React, { useState, useEffect } from 'react'
import { NavLink, useNavigate } from 'react-router-dom';
import './login_register.css'
import { BASE_URL } from '../helper'
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CircularProgress from '@mui/material/CircularProgress';

export default function Login() {

    const navigate = useNavigate();

    const [userdata, setuserdata] = useState({ email: "", password: "" })
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const response = await fetch(`${BASE_URL}/api/loginuser`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ email: userdata.email, password: userdata.password })
        });
        const json = await response.json()
        console.log(json);

        if (json.errors) {
            toast.error(json.errors, {
                position: "top-center",
                autoClose: 2000,
            });
        }
        if (json.success) {
            toast.success("login Successfully done 😃!", {
                position: "top-center",
                autoClose: 2000,
                onClose: () => {
                    localStorage.setItem("userEmail", userdata.email);
                    localStorage.setItem("authToken", json.authToken)
                //    console.log( localStorage.getItem("authToken"))
                //    console.log(localStorage.getItem("userEmail"));
                  navigate("/");
                }
              });
        }
    }

    const changevalue = (event) => {
        setuserdata({ ...userdata, [event.target.name]: event.target.value })

    }

    useEffect(() => {
        // Simulating an asynchronous data fetch
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      }, []);
    
      if (isLoading) {
        return (
          <div className="cart_section">
            <div className="circle">
              <CircularProgress />
              <h2>Loading....</h2>
            </div>
          </div>
        );
      }
    


    return (
        <>
            <div className="sign_container">
                <div className="sign_header">
                    <img src="./blacklogoamazon.png" alt="signupimg" />
                </div>
                <div className="sign_form">
                    <form onSubmit={handleSubmit}>
                        <h1>Sign-In</h1>

                        <div className="form_data">
                            <label htmlFor="email">Email</label>
                            <input type="email" name="email"
                                onChange={changevalue}
                                value={userdata.email}
                                id="email" />
                        </div>
                        <div className="form_data">
                            <label htmlFor="password">Password</label>
                            <div className="input-with-icon">
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    name="password"
                                    onChange={changevalue}
                                    value={userdata.password}
                                    id="password"
                                    placeholder="At least 6 characters"
                                />
                                {showPassword ? (
                                    <VisibilityOff className="password-icon" onClick={togglePasswordVisibility} />
                                ) : (
                                    <Visibility className="password-icon" onClick={togglePasswordVisibility} />
                                )}
                            </div>
                        </div>
                        <button type="submit" className="signin_btn">Continue</button>
                    </form>
                    <ToastContainer />
                </div>
                <div className="create_accountinfo">
                    <p>New to Amazon?</p>
                    <button><NavLink to="/register">Create your Amazon Account</NavLink></button>
                </div>
            </div>
        </>
    )
}
